

// import React, { useEffect, useState } from "react";
// import "./StudentAttendance.css";

// const STUDENT_API = "https://bodhimaram.onrender.com/api/students";
// const ATTENDANCE_API = "https://bodhimaram.onrender.com/api/attendance/report";

// const AttendanceReport = () => {
//   const [students, setStudents] = useState([]);
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterStatus, setFilterStatus] = useState("All");
//   const [loading, setLoading] = useState(false);

//   // 🔽 NEW
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [monthlyReport, setMonthlyReport] = useState([]);

//   /* ================= HELPERS ================= */
//   const calculatePercentage = (present, total) =>
//     total === 0 ? "0.0" : ((present / total) * 100).toFixed(1);

//   /* ================= LOAD DATA ================= */
//   useEffect(() => {
//     loadAttendance();
//   }, []);

//   const loadAttendance = async () => {
//     try {
//       setLoading(true);

//       const stuRes = await fetch(STUDENT_API);
//       const stuData = await stuRes.json();
//       setStudents(stuData);

//       const finalData = [];

//       for (const s of stuData) {
//         if (!s.st_id) continue;

//         const attRes = await fetch(`${ATTENDANCE_API}/${s.st_id}`);
//         const months = await attRes.json();

//         let totalDays = 0;
//         let present = 0;
//         let lastMarked = "-";

//         months.forEach(m => {
//           totalDays += Number(m.total_days || 0);
//           present += Number(m.present_days || 0);
//         });

//         if (months.length > 0) {
//           const latest = months[0];
//           lastMarked = `${latest.year}-${String(latest.month).padStart(2, "0")}`;
//         }

//         finalData.push({
//           id: s.st_id,          // ✅ st_id only
//           name: s.childname,
//           rollNo: s.st_id,
//           totalDays,
//           present,
//           lastMarked,
//         });
//       }

//       setAttendanceData(finalData);
//     } catch (err) {
//       console.error("Attendance load error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= ROW CLICK → MONTHLY ================= */
//   const loadMonthlyReport = async (student) => {
//     setSelectedStudent(student);
//     setMonthlyReport([]);
//     setLoading(true);

//     const res = await fetch(`${ATTENDANCE_API}/${student.id}`);
//     const data = await res.json();

//     setMonthlyReport(data);
//     setLoading(false);
//   };

//   /* ================= FILTER ================= */
//   const filteredStudents = attendanceData.filter((s) => {
//     const percentage = (s.present / (s.totalDays || 1)) * 100;
//     const matchesSearch =
//       s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       s.rollNo.toLowerCase().includes(searchTerm.toLowerCase());

//     if (filterStatus === "Low") return matchesSearch && percentage < 75;
//     if (filterStatus === "High") return matchesSearch && percentage >= 75;
//     return matchesSearch;
//   });

//   /* ================= CSV ================= */
//   const handleDownloadCSV = () => {
//     let csv = "Roll No,Name,Total Days,Present,Percentage\n";

//     filteredStudents.forEach((s) => {
//       csv += `${s.rollNo},${s.name},${s.totalDays},${s.present},${calculatePercentage(
//         s.present,
//         s.totalDays
//       )}%\n`;
//     });

//     const blob = new Blob([csv], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "Attendance_Report.csv";
//     link.click();
//   };

//   /* ================= UI ================= */
//   return (
//     <div className="attendance-container">
//       <header className="report-header">
//         <h2>Student Attendance Report</h2>
//         <button className="download-btn" onClick={handleDownloadCSV}>
//           Export CSV
//         </button>
//       </header>

//       {/* STATS */}
//       <div className="stats-grid">
//         <div className="stat-card">
//           <h3>{attendanceData.length}</h3>
//           <p>Total Students</p>
//         </div>
//         <div className="stat-card warning">
//           <h3>
//             {
//               attendanceData.filter(
//                 s => (s.present / (s.totalDays || 1)) * 100 < 75
//               ).length
//             }
//           </h3>
//           <p>Below 75%</p>
//         </div>
//       </div>

//       {/* FILTERS */}
//       <div className="filter-bar">
//         <input
//           type="text"
//           placeholder="Search Name or Roll No..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />

//         <select
//           value={filterStatus}
//           onChange={(e) => setFilterStatus(e.target.value)}
//         >
//           <option value="All">All Attendance</option>
//           <option value="High">Above 75%</option>
//           <option value="Low">Below 75%</option>
//         </select>
//       </div>

//       {/* MAIN TABLE */}
//       <div className="table-scroll">
//         <table className="attendance-table">
//           <thead>
//             <tr>
//               <th>Roll No</th>
//               <th>Student Name</th>
//               <th>Attendance %</th>
//               <th>Status</th>
//               <th>Last Active</th>
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="5" style={{ textAlign: "center" }}>
//                   Loading...
//                 </td>
//               </tr>
//             ) : filteredStudents.length === 0 ? (
//               <tr>
//                 <td colSpan="5" style={{ textAlign: "center" }}>
//                   No records found
//                 </td>
//               </tr>
//             ) : (
//               filteredStudents.map((student) => {
//                 const percent = calculatePercentage(
//                   student.present,
//                   student.totalDays
//                 );

//                 return (
//                   <tr
//                     key={student.id}
//                     className="clickable-row"
//                     onClick={() => loadMonthlyReport(student)}
//                   >
//                     <td>{student.rollNo}</td>
//                     <td>{student.name}</td>
//                     <td>
//                       <div className="progress-bar-bg">
//                         <div
//                           className="progress-bar-fill"
//                           style={{
//                             width: `${percent}%`,
//                             backgroundColor:
//                               percent < 75 ? "#ff4d4d" : "#4caf50",
//                           }}
//                         />
//                       </div>
//                       <span className="percent-text">{percent}%</span>
//                     </td>
//                     <td>
//                       <span
//                         className={`status-pill ${
//                           percent < 75 ? "shortage" : "good"
//                         }`}
//                       >
//                         {percent < 75 ? "Shortage" : "Regular"}
//                       </span>
//                     </td>
//                     <td>{student.lastMarked}</td>
//                   </tr>
//                 );
//               })
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* 🔽 MONTHLY REPORT */}
//       {selectedStudent && (
//         <>
//           <h3 style={{ marginTop: "20px" }}>
//             Monthly Report – {selectedStudent.name}
//           </h3>

//           <div className="table-scroll">
//             <table className="attendance-table">
//               <thead>
//                 <tr>
//                   <th>Year</th>
//                   <th>Month</th>
//                   <th>Total Days</th>
//                   <th>Present</th>
//                   <th>Absent</th>
//                   <th>Attendance %</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {monthlyReport.map((m, i) => (
//                   <tr key={i}>
//                     <td>{m.year}</td>
//                     <td>{m.month}</td>
//                     <td>{m.total_days}</td>
//                     <td>{m.present_days}</td>
//                     <td>{m.absent_days}</td>
//                     <td>
//                       {calculatePercentage(
//                         m.present_days,
//                         m.total_days
//                       )}%
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default AttendanceReport;



import React, { useEffect, useState } from "react";
import "./StudentAttendance.css";

const STUDENT_API = "https://bodhimaram.onrender.com/api/students";
const ATTENDANCE_API = "https://bodhimaram.onrender.com/api/attendance/report";



const AttendanceReport = () => {
  const [students, setStudents] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [loading, setLoading] = useState(false);

  // 🔽 NEW
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [monthlyReport, setMonthlyReport] = useState([]);

  /* ================= HELPERS ================= */
  const calculatePercentage = (present, total) =>
    total === 0 ? "0.0" : ((present / total) * 100).toFixed(1);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    loadAttendance();
  }, []);

  const loadAttendance = async () => {
    try {
      setLoading(true);

      const stuRes = await fetch(STUDENT_API);
      const stuData = await stuRes.json();
      setStudents(stuData);

      const finalData = [];

      for (const s of stuData) {
        if (!s.st_id) continue;

        const attRes = await fetch(`${ATTENDANCE_API}/${s.st_id}`);
        const months = await attRes.json();

        let totalDays = 0;
        let present = 0;
        let lastMarked = "-";

        months.forEach(m => {
          totalDays += Number(m.total_days || 0);
          present += Number(m.present_days || 0);
        });

        if (months.length > 0) {
          const latest = months[0];
          lastMarked = `${latest.year}-${String(latest.month).padStart(2, "0")}`;
        }

        finalData.push({
          id: s.st_id,          // ✅ st_id only
          name: s.childname,
          rollNo: s.st_id,
          totalDays,
          present,
          lastMarked,
        });
      }

      setAttendanceData(finalData);
    } catch (err) {
      console.error("Attendance load error:", err);
    } finally {
      setLoading(false);
    }
  };

  
  /* ================= ROW CLICK → MONTHLY ================= */
  const loadMonthlyReport = async (student) => {
    setSelectedStudent(student);
    setMonthlyReport([]);
    setLoading(true);

    const res = await fetch(`${ATTENDANCE_API}/${student.id}`);
    const data = await res.json();

    setMonthlyReport(data);
    setLoading(false);
  };


  /* ================= FILTER ================= */
  const filteredStudents = attendanceData.filter((s) => {
    const percentage = (s.present / (s.totalDays || 1)) * 100;
    const matchesSearch =
      s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s.rollNo.toLowerCase().includes(searchTerm.toLowerCase());

    if (filterStatus === "Low") return matchesSearch && percentage < 75;
    if (filterStatus === "High") return matchesSearch && percentage >= 75;
    return matchesSearch;
  });

  /* ================= CSV ================= */
  const handleDownloadCSV = () => {
    let csv = "Roll No,Name,Total Days,Present,Percentage\n";

    filteredStudents.forEach((s) => {
      csv += `${s.rollNo},${s.name},${s.totalDays},${s.present},${calculatePercentage(
        s.present,
        s.totalDays
      )}%\n`;
    });

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Attendance_Report.csv";
    link.click();
  };

  /* ================= UI ================= */
  return (
    <div className="attendance-container">
      <header className="report-header">
        <h2>Student Attendance Report</h2>
        <button className="download-btn" onClick={handleDownloadCSV}>
          Export CSV
        </button>
      </header>

      {/* STATS */}
      <div className="stats-grid">
        <div className="stat-card">
          <h3>{attendanceData.length}</h3>
          <p>Total Students</p>
        </div>
        <div className="stat-card warning">
          <h3>
            {
              attendanceData.filter(
                s => (s.present / (s.totalDays || 1)) * 100 < 75
              ).length
            }
          </h3>
          <p>Below 75%</p>
        </div>
      </div>

      {/* FILTERS */}
      <div className="filter-bar">
        <input
          type="text"
          placeholder="Search Name or Roll No..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <option value="All">All Attendance</option>
          <option value="High">Above 75%</option>
          <option value="Low">Below 75%</option>
        </select>
      </div>

      {/* MAIN TABLE */}
      <div className="table-scroll">
        <table className="attendance-table">
          <thead>
            <tr>
              <th>Clase</th>
              <th>Student Name</th>
              <th>Attendance %</th>
              <th>Status</th>
              <th>Last Active</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : filteredStudents.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No records found
                </td>
              </tr>
            ) : (
              filteredStudents.map((student) => {
                const percent = calculatePercentage(
                  student.present,
                  student.totalDays
                );

                return (
                  <tr
                    key={student.id}
                    className="clickable-row"
                    onClick={() => loadMonthlyReport(student)}
                  >
                    <td>{student.className}</td>
                    <td>{student.name}</td>
                    <td>
                      <div className="progress-bar-bg">
                        <div
                          className="progress-bar-fill"
                          style={{
                            width: `${percent}%`,
                            backgroundColor:
                              percent < 75 ? "#ff4d4d" : "#4caf50",
                          }}
                        />
                      </div>
                      <span className="percent-text">{percent}%</span>
                    </td>
                    <td>
                      <span
                        className={`status-pill ${
                          percent < 75 ? "shortage" : "good"
                        }`}
                      >
                        {percent < 75 ? "Shortage" : "Regular"}
                      </span>
                    </td>
                    <td>{student.lastMarked}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
        

      {/* mobile */}
   {/* issue */}
      <div className="mobile-student-list">
  {filteredStudents.map((student) => {
    const percent = calculatePercentage(
      student.present,
      student.totalDays
    );

    return (
      <div
        key={student.id}
        className="student-card"
        onClick={() => loadMonthlyReport(student)}
      >
        <div className="student-top">
          <div>
            <div className="student-name">
              {student.name}
            </div>

            <div className="student-roll">
              {student.className}
            </div>
          </div>

          <div
            className="student-percent"
            style={{
              color:
                percent < 75
                  ? "#ef4444"
                  : "#16a34a",
            }}
          >
            {percent}%
          </div>
        </div>

        <div className="student-progress">
          <div
            className="student-fill"
            style={{
              width: `${percent}%`,
              background:
                percent < 75
                  ? "#ef4444"
                  : "#16a34a",
            }}
          />
        </div>
      </div>
    );
  })}
</div>




      {/* 🔽 MONTHLY REPORT */}
      {selectedStudent && (
        <>
          <h3 style={{ marginTop: "20px" }}>
            Monthly Report – {selectedStudent.name}
          </h3>

          <div className="table-scroll">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>Year</th>
                  <th>Month</th>
                  <th>Total Days</th>
                  <th>Present</th>
                  <th>Absent</th>
                  <th>Attendance %</th>
                </tr>
              </thead>
              <tbody>
                {monthlyReport.map((m, i) => (
                  <tr key={i}>
                    <td>{m.year}</td>
                    <td>{m.month}</td>
                    <td>{m.total_days}</td>
                    <td>{m.present_days}</td>
                    <td>{m.absent_days}</td>
                    <td>
                      {calculatePercentage(
                        m.present_days,
                        m.total_days
                      )}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* <div className="mobile-monthly-report">
  {monthlyReport.map((m, i) => (
    <div key={i} className="month-card">
      <div><strong>Year:</strong> {m.year}</div>
      <div><strong>Month:</strong> {m.month}</div>
      <div><strong>Total Days:</strong> {m.total_days}</div>
      <div><strong>Present:</strong> {m.present_days}</div>
      <div><strong>Absent:</strong> {m.absent_days}</div>
      <div>
        <strong>Attendance:</strong>{" "}
        {calculatePercentage(
          m.present_days,
          m.total_days
        )}%
      </div>
    </div>
  ))}
</div> */}
          </div>

       

        <div className="mobile-monthly-report">
  <div className="month-card">

    <div className="month-head-row">
      <span>Year</span>
      <span>Month</span>
      <span>Total</span>
      <span>Present</span>
      <span>Absent</span>
      <span>%</span>
    </div>

    {monthlyReport.map((m, i) => (
      <div key={i} className="month-data-row">
        <span>{m.year}</span>
        <span>{m.month}</span>
        <span>{m.total_days}</span>
        <span>{m.present_days}</span>
        <span>{m.absent_days}</span>
        <span>
          {calculatePercentage(
            m.present_days,
            m.total_days
          )}%
        </span>
      </div>
    ))}

  </div>
</div>


        </>
      )}
    </div>
  );
};

export default AttendanceReport;